import React, { useState, useEffect } from 'react'
import { Button, Input, Select, Table, Checkbox } from 'antd'
import 'aos/dist/aos.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Option } from 'antd/es/mentions'
import {
  GetRateSheetApprovalList,
  GetRateSheetByOrderNumber,
  GetRateSheetBulkApproval,
  UpdateOrderEntrySecond,
  GetRateSheetRateUpdate,
} from '../../AllAPI/SalesAPI/SalesApi'
import DataTable from 'react-data-table-component'
import { useNavigate, useParams } from 'react-router-dom'

const RateSheetApprovalDetails = () => {
  const navigate = useNavigate()
  const { orderId } = useParams()
  console.log('Order id', orderId)
  const commonHeaders = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
      userIp: '',
      userLat: '',
      userLong: '',
      deviceSign: '',
    },
  }
  const [errors, setErrors] = useState({
    selectedId: '',
  })

  const goodTypesOptions = [
    { value: '1', label: 'F.T' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'Inch' },
  ]
  const [allOrders, setAllOrders] = useState([])
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [selectedOrder1, setSelectedOrder1] = useState(null)

  const [orderItems, setOrderItems] = useState([])
  const [approvedItems, setApprovedItems] = useState(new Set())
  const [selectAll, setSelectAll] = useState(false)
  const [selectedId, setSelectedId] = useState('')
  const [orderPass, setOrderPass] = useState(false)

  const [pageSize, setPageSize] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)
  const [isBulkSelecting, setIsBulkSelecting] = useState(false)

  //======Search data from table===============
  const handleSearch = (value) => {
    const searchValue = value.toLowerCase()

    const filtered = orderItems.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? '')
          .toLowerCase()
          .includes(searchValue),
      ),
    )

    setFilteredData(filtered)
    setTotalEntries(filtered.length) // Update total entries count after filtering
    setCurrentPage(1)
  }
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

  useEffect(() => {
    const userData = sessionStorage.getItem('authToken')
    if (!userData) {
      navigate('/login')
    }
  }, [])

  // useEffect(() => {
  //   const userData = sessionStorage.getItem('userData')
  //   if (!userData) {
  //     navigate('/login')
  //   }
  // }, [])

  //=========================== Getting AUTH TOken from session storage ============================================================================
  //    useEffect(() => {
  //   const userData = sessionStorage.getItem("userData");
  //     console.log("User Data",userData);

  //   if (!userData) {
  //     navigate("/login");
  //   }
  // }, []);

  //     // ==============Get  data================
  //        let isRateApprovalFetched = false;
  //   useEffect(() => {
  //     if (isRateApprovalFetched) return;

  //     fetchRateSheetData();
  //     isRateApprovalFetched = true;
  //   }, []);

  useEffect(() => {
    console.log('useEffect triggered')
    console.log('useEffect triggered, orderId:==>>', orderId) // Add this line

    //  const savedData = localStorage.getItem("selectedOrderData");
    //   if (savedData) {
    //     const { orderInfo } = JSON.parse(savedData);
    //     setSelectedOrder1(orderInfo);

    //   }
    fetchOrderData(orderId)
    //console.log("Slected order",selectedOrder1);
    //fetchRateSheetData(orderId);
  }, [orderId])

  const fetchRateSheetData = async (orderId) => {
    try {
      // const response = await axios.get("http://192.168.29.1getRateSheetApprovalList16:8182/sales/RateSheetApproval/getRateSheetApprovalList",commonHeaders);
      const response = await axios.get(GetRateSheetApprovalList, commonHeaders)

      setAllOrders(response.data)
      const allOrderList = response.data
      const order = allOrderList.find((o) => o.id === orderId)

      // Ensure that order is found before setting selectedOrder

      setSelectedOrder(order)
      console.log('Selected Order after Rate Sheet fetch:', order)
      fetchOrderData(orderId)

      console.log('Selected Order', selectedOrder)
    } catch (error) {
      console.error('Error fetching Rate Sheet data:', error)
      toast.error('Error fetching Rate Sheet data:')
    }
  }

  const handleOrderSelect = async (orderId) => {
    const order = allOrders.find((o) => o.id === orderId)
    setSelectedOrder(order)
  }

  const toggleItemSelection = (itemId, isChecked) => {
    setApprovedItems((prev) => {
      const updated = new Set(prev)
      isChecked ? updated.add(itemId) : updated.delete(itemId)

      setIsBulkSelecting(updated.size > 1)
      return updated
    })
  }

  const handleItemApproval = async (itemId, currentrateStatus) => {
    if (approvedItems.has(itemId)) {
      const newrateStatus =
        currentrateStatus === 0 ? 1 : currentrateStatus === 1 ? 2 : 1
      await approveItems([itemId], newrateStatus) // Wrap single ID in array
    } else {
      toast.warn('Please select the checkbox before approving.')
    }
  }

  const handleBulkApprove = async () => {
    const idsToApprove = Array.from(approvedItems)

    if (idsToApprove.length > 0) {
      const selectedStatuses = orderItems
        .filter((item) => approvedItems.has(item.id))
        .map((item) => item.rateStatus)

      const allApproved = selectedStatuses.every((status) => status === 1)
      const newStatus = allApproved ? 2 : 1

      await approveItems(idsToApprove, newStatus)

      setApprovedItems(new Set())
      setSelectAll(false)
      setIsBulkSelecting(false)
    } else {
      toast.warn('No items selected for bulk action.')
    }
  }
  //========================================= For Bulk Approval /Rejection Button =====================================
  const selectedStatuses = orderItems
    .filter((item) => approvedItems.has(item.id))
    .map((item) => item.rateStatus)

  const bulkActionType =
    selectedStatuses.length > 0 &&
    selectedStatuses.every((status) => status === 1)
      ? 'reject'
      : 'approve'

  const buttonText =
    bulkActionType === 'approve'
      ? 'Approve Selected Items'
      : 'Reject Selected Items'
  const buttonColor = bulkActionType === 'approve' ? '#28a745' : '#dc3545'
  //=======================================================================================

  const approveItems = async (orderNumberIds, rateStatus) => {
    const requestBody = {
      id: orderNumberIds,
      rateStatus: 1,
    }
    // const requestBody = orderNumberIds.map((orderNumber) => ({
    //   finalOrderNumber: orderNumber,
    //   orderNumberId: selectedId,
    //   itemApproval: 1 ,
    // }));
    const queryString = orderNumberIds.map((id) => `ids=${id}`).join('&')
    try {
      const response = await axios.post(
        `${GetRateSheetBulkApproval}?ids=${orderNumberIds}&rateStatus=${rateStatus}`,
        null,
        commonHeaders,
        //`${GetRateSheetBulkApproval}?${queryString}&rateStatus=${rateStatus}`,null,commonHeaders
      )

      if (response.data === 'OK') {
        const action = rateStatus === 1 ? 'Approved' : 'Rejected'
        toast.success(`${action} successfully!`)
        fetchOrderData(orderId)
        // setSelectedOrder(null);
        // setOrderItems([]);
        // setApprovedItems(new Set());
        // fetchRateSheetData();
      } else if (response.data === 'alreadyexisted') {
        toast.warn('Item(s) already approved!')
      }
    } catch (error) {
      console.error('Error during approval:', error)
      toast.error('Error occurred while approving item(s)')
    }
  }

  // const handleSelectAll = (e) => {
  //   const checked = e.target.checked;
  //   setSelectAll(checked);
  //   setIsBulkSelecting(checked); // update bulk selecting state
  //   if (checked) {
  //     const allIds = orderItems.map((item) => item.id);
  //     setApprovedItems(new Set(allIds));
  //   } else {
  //     setApprovedItems(new Set());
  //   }
  // };
  const handleSelectAll = (e) => {
    const checked = e.target.checked
    setSelectAll(checked)
    setIsBulkSelecting(checked)

    if (checked) {
      const allIds = orderItems.map((item) => item.id)
      setApprovedItems(new Set(allIds))

      // Merge with existing editedRates
      const updatedRates = { ...editedRates } // keep previous edits
      orderItems.forEach((item) => {
        // const existing = editedRates[item.finalOrderNumber];
        const existing = editedRates[item.id]

        //  updatedRates[item.finalOrderNumber] = {
        updatedRates[item.id] = {
          basicOrderRate:
            existing?.basicOrderRate ?? (item.basicOrderRate || 0),
          packingRate: existing?.packingRate ?? (item.packingRate || 0),
          premium: existing?.premium ?? (item.premium || 0),
        }
      })

      setEditedRates(updatedRates)
    } else {
      setApprovedItems(new Set())
      // setEditedRates({}); // clear rates if deselecting all
    }
  }

  const [editedRates, setEditedRates] = useState({})

  // const handleRateChange = (orderNumber, field, value) => {
  //   setEditedRates((prev) => {
  //     const updated = {
  //       ...prev,
  //       [orderNumber]: {
  //         ...prev[orderNumber],
  //         [field]: parseFloat(value) || 0,
  //       },
  //     };
  //     return updated;
  //   });
  // };
  // const handleRateChange = (orderId, field, value) => {
  //   setEditedRates((prevRates) => {
  //     const prevEntry = prevRates[orderId] || {};

  //     return {
  //       ...prevRates,
  //       [orderId]: {
  //         ...prevEntry, // keep existing fields (e.g., premium, packingRate)
  //         [field]: value, // update only the changed field
  //       },
  //     };
  //   });
  // };
  // const handleRateChange = (orderId, field, value) => {
  //   setEditedRates((prevRates) => {
  //     const prevEntry = prevRates[orderId];

  //     // If this is the first time we're editing this row
  //     if (!prevEntry) {
  //       const originalRow = orderItems.find((row) => row.finalOrderNumber === orderId);
  //       return {
  //         ...prevRates,
  //         [orderId]: {
  //           basicOrderRate: originalRow?.basicOrderRate ?? "",
  //           premium: originalRow?.premium ?? "",
  //           packingRate: originalRow?.packingRate ?? "",
  //           [field]: value, // override the changed field with new value
  //         },
  //       };
  //     }

  //     // If already edited before, just update the changed field
  //     return {
  //       ...prevRates,
  //       [orderId]: {
  //         ...prevEntry,
  //         [field]: value,
  //       },
  //     };
  //   });
  // };
  const handleRateChange = (orderId, field, value) => {
    setEditedRates((prevRates) => {
      const prevEntry = prevRates[orderId]
      const originalRow = orderItems.find((row) => row.id === orderId) // Fixed here

      // Use existing values or fallback to original
      return {
        ...prevRates,
        [orderId]: {
          basicOrderRate:
            prevEntry?.basicOrderRate ?? originalRow?.basicOrderRate ?? 0,
          premium: prevEntry?.premium ?? originalRow?.premium ?? 0,
          packingRate: prevEntry?.packingRate ?? originalRow?.packingRate ?? 0,
          [field]: value, // this will override one of the above if needed
        },
      }
    })
  }

  const getCalculatedRate = (record) => {
    if (!record || !record.finalOrderNumber) return '0.00' // fallback if record is null or missing keys

    // const edited = editedRates[record.finalOrderNumber] || {};
    const edited = editedRates[record.id] || {}

    const basic = Number(edited.basicOrderRate ?? record.basicOrderRate ?? 0)
    const premium = Number(edited.premium ?? record.premium ?? 0)
    const packing = Number(edited.packingRate ?? record.packingRate ?? 0)

    return (basic + premium + packing).toFixed(2)
  }

  const updateRates = async (id) => {
    const selectedRateUpdates = []

    approvedItems.forEach((id) => {
      const record = orderItems.find((item) => item.id === id)
      // const edited = editedRates[record.finalOrderNumber];
      const edited = editedRates[record.id]
      if (!record || !edited) return

      selectedRateUpdates.push({
        id: record.id,
        basicOrderRate: parseFloat(edited.basicOrderRate),
        packingRate: parseFloat(edited.packingRate),
        premium: parseFloat(edited.premium),
      })
    })

    // const requestBody = {
    //   id,
    //   basicOrderRate: parseFloat(edited.basicOrderRate),
    //   packingRate: parseFloat(edited.packingRate),
    //   premium: parseFloat(edited.premium),
    // };

    try {
      const response = await axios.put(
        GetRateSheetRateUpdate,
        selectedRateUpdates,
        commonHeaders,
      )

      if (response.data === 'UPDATED') {
        toast.success('Rates updated successfully!')
        fetchOrderData(orderId)

        return true
      } else {
        toast.warn('Unexpected response: ' + response.data)
        return false
      }
    } catch (error) {
      console.error('Rate update failed:', error)
      toast.error('Rate update failed.')
      return false
    }
  }

  const columns = [
    {
      name: 'Sr. No.',
      cell: (row, index) =>
        row.isTotalRow ? '' : (currentPage - 1) * pageSize + index + 1,
      width: '80px',
    },
    {
      // name: " Item Entry Date",
      name: (
        <div>
          Item Entry
          <br />
          Date
        </div>
      ),

      selector: (row) => {
        if (row.isTotalRow) return ''

        const date = row.itemEntryDate
        if (!date) return '-'
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      sortable: true,
    },
    {
      // name: "Item Name",
      name: (
        <div>
          Item <br />
          Name
        </div>
      ),

      selector: (row) => (row.isTotalRow ? '' : row.dieName),
      sortable: true,
      wrap: true,
    },
    {
      name: 'Alloy',
      selector: (row) => (row.isTotalRow ? '' : row.alloyname),
      sortable: true,
            width:"65px",

    },
    {
      name: <div style={{  wordWrap: 'break-word',}}>Temp</div>,
      selector: (row) => (row.isTotalRow ? '' : row.temperName),
      sortable: true,
            width:"65px",

    },
    {
      // name: 'Wt./R',
       name: <div>Wt,<br/>/R</div>,
      selector: (row) => (row.isTotalRow ? '' : row.weightRange),
      sortable: true,
      width:"65px",
    },
    {
      name: 'Length',
      selector: (row) => (row.isTotalRow ? '' : row.length),
      sortable: true,
      cell: (row) => {
        if (row.isTotalRow) return ''

        const unitOption = goodTypesOptions.find(
          (opt) => opt.value === String(row.unit),
        )
        const unitLabel = unitOption ? `(${unitOption.label})` : ''
        return `${row.length ?? ''} ${unitLabel}`
      },
    },
    //  {
    //     name: 'Unit',
    //     selector: (row) => {
    //       const unitOption = goodTypesOptions.find((opt) => opt.value === String(row.unit));
    //       return unitOption ? unitOption.label : ''; // e.g., 'MM' or 'Inch'
    //     },
    //   },
    {
      name: 'Pcs',
      selector: (row) => row.pcs,
      cell: (row) =>
        row.isTotalRow ? (
          <span>
            Total Pcs:
            <br />
            <strong>{row.pcs}</strong>
          </span>
        ) : (
          row.pcs
        ),
      sortable: true,
      wrap: true,
            width:"65px",

    },
    {
      // name: "Quantity (Kgs.)",
      name: (
        <div>
          Qty
          <br />
          (Kgs.)
        </div>
      ),
      selector: (row) => row.qty,
      cell: (row) =>
        row.isTotalRow ? (
          <span>
            {' '}
            Total Qty:
            <br />
            <strong>{row.qty}</strong>{' '}
          </span>
        ) : (
          row.qty
        ),
      sortable: true,
      wrap: true,
            width:"65px",
           

    },
    {
      name: (
        <div>
          Basic
          <br />
          Rate
        </div>
      ),
      selector: (row) => (row.isTotalRow ? '' : row.basicOrderRate),
      sortable: true,
            width:"65px",

    },
    {
      name: <div style={{  wordWrap: 'break-word',}}>Premium </div>,
      selector: (row) => (row.isTotalRow ? '' : row.premium),
      sortable: true,
            width:"65px",

    },
    {
      // name: "Packaging Rate",
      name: (
       <div style={{  wordWrap: 'break-word',}}>
          Packing
          <br />
          Rate
        </div>
      ),
      selector: (row) => (row.isTotalRow ? '' : row.packingRate),
      sortable: true,
            width:"65px",

    },
    //   {
    //     // name: "Basic Rate (New)",
    //     name: <div>Basic<br />Rate(New)</div>,
    // sortable: true,
    //     cell: (row) => (
    //       (row.isTotalRow ? null : <Input
    //         type="number"
    //         style={{ width: 90 }}
    //         value={
    //           editedRates[row.finalOrderNumber]?.basicOrderRate !== undefined
    //             ? editedRates[row.finalOrderNumber].basicOrderRate
    //             : row.basicOrderRate ?? ""
    //         }
    //         onChange={(e) =>
    //           handleRateChange(row.finalOrderNumber, "basicOrderRate", e.target.value)
    //         }
    //       />)
    //     ),
    //   },
    //   {
    //     name: "Premium (New)",
    //     sortable: true,
    //     cell: (row) => (
    //       (row.isTotalRow ? null : <Input
    //         type="number"
    //         style={{ width: 90 }}
    //         value={
    //           editedRates[row.finalOrderNumber]?.premium !== undefined
    //             ? editedRates[row.finalOrderNumber].premium
    //             : row.premium ?? ""
    //         }
    //         onChange={(e) =>
    //           handleRateChange(row.finalOrderNumber, "premium", e.target.value)
    //         }
    //       />)
    //     ),
    //   },
    //   {
    //     // name: "Packaging Rate (New)",
    //     name: <div>Packing<br />Rate(New)</div>,
    //     sortable: true,
    //     cell: (row) => (
    //        (row.isTotalRow ? null :<Input
    //         type="number"
    //         style={{ width: 90 }}
    //         value={
    //           editedRates[row.finalOrderNumber]?.packingRate !== undefined
    //             ? editedRates[row.finalOrderNumber].packingRate
    //             : row.packingRate ?? ""
    //         }
    //         onChange={(e) =>
    //           handleRateChange(row.finalOrderNumber, "packingRate", e.target.value)
    //         }
    //       />)
    //     ),
    //   },
    {
      // name: "Basic Rate (New)",
      name: (
        <div>
          Basic
          <br />
          Rate(New)
        </div>
      ),
      sortable: true,
      cell: (row) =>
        row.isTotalRow ? null : (
          <Input
            type="number"
            style={{ width: 90 }}
            value={
              editedRates[row.id]?.basicOrderRate !== undefined
                ? editedRates[row.id].basicOrderRate
                : row.basicOrderRate ?? ''
            }
            onChange={(e) =>
              handleRateChange(row.id, 'basicOrderRate', e.target.value)
            }
          />
        ),
    },
    {
      name:  
          <div style={{  wordWrap: 'break-word',}}>
          Premium
          <br />
          (New)
        </div>,
      sortable: true,
      cell: (row) =>
        row.isTotalRow ? null : (
          <Input
            type="number"
            style={{ width: 90 }}
            value={
              editedRates[row.id]?.premium !== undefined
                ? editedRates[row.id].premium
                : row.premium ?? ''
            }
            onChange={(e) =>
              handleRateChange(row.id, 'premium', e.target.value)
            }
          />
        ),
    },
    {
      // name: "Packaging Rate (New)",
      name: (
        <div>
          Packing
          <br />
          Rate(New)
        </div>
      ),
      sortable: true,
      cell: (row) =>
        row.isTotalRow ? null : (
          <Input
            type="number"
            style={{ width: 90 }}
            value={
              editedRates[row.id]?.packingRate !== undefined
                ? editedRates[row.id].packingRate
                : row.packingRate ?? ''
            }
            onChange={(e) =>
              handleRateChange(row.id, 'packingRate', e.target.value)
            }
          />
        ),
    },
    {
      // name: "Final Rate (New)",
      name: (
        <div>
          Final
          <br />
          Rate(New)
        </div>
      ),
      sortable: true,
      cell: (row) =>
        row.isTotalRow ? null : <span>{getCalculatedRate(row)}</span>,
    },
    {
      name: (
        <div>
          Total
          <br />
          Rate
        </div>
      ),
      selector: (row) => (row.isTotalRow ? '' : row.totalRate),
      sortable: true,
    },
    {
      // name: "Item Approval",
      name: (
        <div>
          Item
          <br />
          Approval
        </div>
      ),
      sortable: true,
      selector: (row) => {
        if (row.isTotalRow) return ''
        if (row.rateStatus === 1) return 'Approved'
        else if (row.rateStatus === 2) return 'Rejected'
        else return 'Pending'
      },
    },
    {
      name: (
        <span>
          Select All <Checkbox checked={selectAll} onChange={handleSelectAll} />
        </span>
      ),
      cell: (row) =>
        row.isTotalRow ? null : (
             <div
        style={{
          display: 'inline-block',
          padding: '4px',
          borderRadius: '4px',
          backgroundColor: '#023e7d', // Always highlight
        }}
      >
          <Checkbox
          
            checked={approvedItems.has(row.id)}
            onChange={(e) => toggleItemSelection(row.id, e.target.checked)}
          /></div>
        ),
    },
    {
      name: 'Approve',
      cell: (row) =>
        row.isTotalRow ? null : (
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button
              type="primary"
              style={{ backgroundColor: '#28a745', fontSize: '12px' }}
              onClick={() => {
                if (approvedItems.has(row.id)) {
                  updateRates(row.id)
                } else {
                  toast.warn(
                    'Please select the checkbox before updating the rate.',
                  )
                }
              }}
            >
              Update Rate
            </Button>
            <Button
              style={{
                backgroundColor: row.rateStatus === 1 ? '#dc3545' : '#007bff',
                color: '#fff',
                fontSize: '12px',
              }}
              onClick={() => handleItemApproval(row.id, row.rateStatus)}
            >
              {row.rateStatus === 1 ? 'Reject' : 'Approve'}
            </Button>
          </div>
        ),
      width: '200px',
    },
  ]
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: '#023e7d',
        color: '#fff',
        fontSize: '15px',
      },
    },
     headCells: {
    style: {
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      textAlign: 'center',
    
      padding: '4px',   // Optional: Reduce padding
    },
  },
    rows: {
      style: {
        backgroundColor: '#f0f7fd',
        fontSize: '15px',
      },
      rows: {
        style: (row) => ({
          backgroundColor: row.isTotalRow ? '#e1ecf4' : 'white',
          fontWeight: row.isTotalRow ? 'bold' : 'normal',
        }),
      },
    },
    cells: {
      style: {
        maxWidth: '200px', // Ensure buttons and long text fit
        padding: '8px',
      },
    },
  }
  const totalQty = filteredData.reduce(
    (acc, row) => acc + (Number(row.qty) || 0),
    0,
  )
  const totalPcs = filteredData.reduce(
    (acc, row) => acc + (Number(row.pcs) || 0),
    0,
  )
  console.log('Total Qty', totalQty)
  console.log('Total Pcs', totalQty)
  const dataWithTotal = [
    ...filteredData,
    {
      length: 'Total',
      pcs: totalPcs,
      qty: totalQty,
      isTotalRow: true, // flag to identify total row
    },
  ]
  const customFooter = () => (
    <tr style={{ backgroundColor: '#e1ecf4', fontWeight: 'bold' }}>
      <td></td> {/* Empty cell for the first column */}
      <td></td> {/* Empty cell for the second column */}
      <td></td>{' '}
      {/* Empty cells for other columns (adjust based on your table) */}
      <td>Total Qty: {totalQty}</td>{' '}
      {/* Display total quantity under the "Qty" column */}
      <td>Total Pcs: {totalPcs}</td>{' '}
      {/* Display total pcs under the "Pcs" column */}
    </tr>
  )
  let isError = false
  const fetchOrderData = async (orderId) => {
    // const order = allOrders.find((o) => o.id  === orderId);
    // setSelectedOrder(order);

    try {
      const response = await axios.get(
        `${GetRateSheetByOrderNumber}?orderNumberId=${orderId}`,
        commonHeaders,
      )

      const orderDetails = response.data

      if (!orderDetails) {
        toast.error('Failed to fetch order details.')
        return
      }

      console.log('Order details fetched successfully:', orderDetails)

      // You can now process or submit the orderDetails further
      if (orderDetails && orderDetails.length > 0) {
        // Assuming that the first object contains the order data you're looking for
        const order = orderDetails[0] // Adjust this if you need a specific order from the response

        // Extract the common order data
        const commonOrderData = {
          orderNumber: order.orderNumber,
          poNumber: order.poNumber,
          customerName: order.customerName,
          poDate: order.poDate,
          entryDate: order.entryDate,
          // Add any other common fields you need here
        }

        // Set the extracted common order data to the state
        setSelectedOrder(commonOrderData) // Set order details
        setOrderItems(orderDetails) // Assuming items are part of the response
        setFilteredData(orderDetails) // Also set the filtered data initially
        setTotalEntries(orderDetails.length)
        console.log('Selected Order', selectedOrder)
        console.log('Common Order Data', commonOrderData)
        //  const order = allOrders.find(o => o.id === parseInt(orderId));
        // setSelectedOrder(order);
        // console.log("Selected Order",selectedOrder);//something is wrong
      } else {
        toast.warn('No items found for the selected order.')
      }
    } catch (error) {
      console.error('Error during order submission:', error)
      toast.error('An error occurred while processing the order.')
    }
  }
  useEffect(() => {
    if (selectedOrder) {
      console.log('Selected Order Updated:', selectedOrder)
      //  handleOrderSelect(orderId);
    }
  }, [selectedOrder])
  return (
    <div className="px-5 py-3" style={{ fontSize: '15px' }}>
      <div
        className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
        style={{ backgroundColor: '#e0efff', minHeight: '800px' }}
      >
        <div className="col-12">
          <div className="p-0 m-0">
            <div className="row px-md-5 mt-3 p-2">
              <div className="row p-0 m-0">
                <div className="col-12 col-lg-4"></div>

                <div className="col-12 col-lg-4"></div>
              </div>

              <div
                className="shadow border p-4 mb-4"
                style={{ backgroundColor: '#f8f9fa' }}
              >
                <div className="order-summary my-3 px-4">
                  <h6 className="mb-3" style={{fontSize: "21px",fontWeight:"bold"}}>
                    Order Details:
                  </h6>
                  <div className="container-fluid">
                    <div className="row">
                      {/* Left column */}
                      <div className="col-md-4">
                        <div
                          className="d-flex mb-3"
                          style={{ fontSize: '17px' }}
                        >
                          <span
                            style={{ minWidth: '110px', marginRight: '10px' }}
                          >
                            Order Number:
                          </span>
                          <strong style={{ fontSize: '17px' }}>
                            {' '}
                            {selectedOrder ? selectedOrder.orderNumber : ''}
                          </strong>
                        </div>
                        <div className="d-flex" style={{ fontSize: '17px' }}>
                          <span
                            style={{ minWidth: '110px', marginRight: '10px' }}
                          >
                            PO No.:
                          </span>
                          <strong style={{ fontSize: '17px' }}>
                            {selectedOrder ? selectedOrder.poNumber : ''}
                          </strong>
                        </div>
                      </div>

                      {/* Right column */}
                      <div className="col-md-4">
                        <div
                          className="d-flex mb-3"
                          style={{ fontSize: '17px' }}
                        >
                          <span
                            style={{ minWidth: '130px', marginRight: '10px' }}
                          >
                            Order Entry Date:
                          </span>
                          <strong>
                            {selectedOrder ? selectedOrder.entryDate : ''}
                          </strong>
                        </div>
                        <div className="d-flex " style={{ fontSize: '17px' }}>
                          <span
                            style={{ minWidth: '130px', marginRight: '10px' }}
                          >
                            Customer:
                          </span>
                          <strong style={{ fontSize: '17px' }}>
                            {selectedOrder ? selectedOrder.customerName : ''}
                          </strong>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div
                          className="d-flex mb-3"
                          style={{ fontSize: '17px' }}
                        >
                          <span
                            style={{
                              minWidth: '130px',
                              marginRight: '10px',
                              fontSize: '17px',
                            }}
                          >
                            PO Date:
                          </span>
                          <strong style={{ fontSize: '17px' }}>
                            {selectedOrder ? selectedOrder.poDate : ''}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}

            <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
              <div
                className="col-12 py-3 shadow border"
                style={{ backgroundColor: 'white' }}
              >
                <div
                  className="col-12 px-md-5"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    {/* <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                     <Select
                       defaultValue={pageSize}
                       onChange={handlePageSizeChange}
                       style={{ width: 120, textAlign: "center" }}
                     >
                       <Option value={10}>10</Option>
                       <Option value={20}>20</Option>
                       <Option value={30}>30</Option>
                     </Select> */}
                  </div>

                  <div className="pt-4 pt-md-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>

                <div style={{ backgroundColor: 'white' }}>
                  <div
                    style={{
                      overflowX: 'auto',
                      position: 'relative',
                      paddingBottom: '40px',
                    }}
                  >
                    <DataTable
                      columns={columns}
                      // data={filteredData}
                      data={dataWithTotal}
                      pagination
                      paginationPerPage={pageSize}
                      paginationTotalRows={totalEntries}
                      paginationServer
                      paginationComponentOptions={{
                        rowsPerPageText: 'Rows per page:',
                        rangeSeparatorText: 'of',
                        noRowsPerPage: true,
                      }}
                      onChangePage={(page) => setCurrentPage(page)}
                      customStyles={customStyles}
                      persistTableHead
                      highlightOnHover
                      striped
                      // customRow={customFooter}
                      noDataComponent={
                        <></>
                        //     <tfoot style={{   position: "sticky",
                        // bottom: 0,
                        // backgroundColor: "#e1ecf4",
                        // fontWeight: "bold",}}>
                        //       <tr>
                        //         {/* Empty cells to align totals under the correct columns */}
                        //         <td colSpan={columns.length - 2}></td> {/* Adjust based on number of columns */}
                        //         <td>Total Qty: {totalQty}</td> {/* Display total quantity */}
                        //         <td>Total Pcs: {totalPcs}</td> {/* Display total pcs */}
                        //       </tr>
                        //     </tfoot>
                      }
                    />
                    {/* <tfoot
    style={{
      position: "sticky",  // Sticky position for the footer
      bottom: 0,  // Stick to the bottom of the table
      backgroundColor: "#e1ecf4",
      fontWeight: "bold",
      zIndex: 1,  // Ensures footer is above table content when scrolled
    }}
  >
    <tr>
      <td colSpan={columns.length - 2}></td> {/* Adjust based on the number of columns 
      <td>Total Qty: {totalQty}</td>
      <td>Total Pcs: {totalPcs}</td>
    </tr>
  </tfoot> */}

                    {isBulkSelecting && approvedItems.size > 1 && (
                      <div
                        className="text-center px-md-5 mb-3"
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '12px',
                        }}
                      >
                        <Button
                          onClick={handleBulkApprove}
                          style={{
                            backgroundColor: buttonColor,
                            borderColor: buttonColor,
                            color: '#fff',
                          }}
                        >
                          {buttonText}
                        </Button>

                        <Button
                          onClick={updateRates}
                          style={{
                            backgroundColor: '#28a745',
                            borderColor: '#28a745',
                            color: '#fff',
                          }}
                        >
                          Bulk Update Rates
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="text-center pt-3">
                <Button
                  type="submit"
                  className="CancelBtn mx-1"
                  onClick={() => {
                    setSelectedOrder(null)
                    setOrderItems([])
                    setApprovedItems(new Set())
                    setEditedRates({})
                    window.close()
                    navigate('/sales5', { state: { refresh: true } })
                    // fetchRateSheetData();
                  }}
                >
                  Back to Page
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RateSheetApprovalDetails